<template>
  <div class="wysiwyg">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Wysiwyg',
  };
</script>

<!-- eslint-disable -->
<style lang="scss">

  .wysiwyg {
    font-weight: 300;

    h1 {
      margin-bottom: space(4);
      font-size: 3em;
      font-weight: 700;
      line-height: 1.1851851852;
    }

    h2 {
      margin-bottom: space(4);
      font-size: 2em;
      font-weight: 700;
      line-height: 1.1944444444;
    }

    h3 {
      margin-bottom: space(4);
      font-size: 1.3333333333em;
      font-weight: 700;
      line-height: 1.3333333333;
    }

    h4 {
      margin-bottom: space(3);
      font-size: 1.2em;
      font-weight: 700;
      line-height: 1.2222222222;
    }

    h5 {
      margin-bottom: space(2);
      font-size: 1.1em;
      font-weight: 700;
      line-height: 1.1111111111;
    }

    h6 {
      margin-bottom: space(2);
      font-size: 1em;
      font-weight: 700;
      line-height: 1;
    }

    p {
      margin-bottom: space(5);
      font-weight: 300;
    }

    strong {
      font-weight: 700;
    }

    em {
      font-style: italic;
    }

    ul {
      margin-bottom: space(7);
    }

    li {
      position: relative;
      display: list-item;
      align-items: center;
      padding-left: space(2);
      padding-bottom: space(2);
      list-style-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik00IDdDNS42NTY4NSA3IDcgNS42NTY4NSA3IDRDNyAyLjM0MzE1IDUuNjU2ODUgMSA0IDFDMi4zNDMxNSAxIDEgMi4zNDMxNSAxIDRDMSA1LjY1Njg1IDIuMzQzMTUgNyA0IDdaIiBzdHJva2U9IiMzNkM4OUIiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==);
      list-style-position: inside;
    }

    img, video {
      margin-top: auto;
      margin-right: auto;
      margin-bottom: space(6);
      margin-left: auto;
      border-radius: 5px;
      box-shadow: $box-shadow;
    }

    a {
      font-weight: 600;
      color: c('green');
      text-decoration: underline;

      &:visited {
        color: c('green');
      }
    }

    details {
      position: relative;
      padding-bottom: space(2);
      font-weight: 300;
    }

    summary {
      margin-bottom: space(2);
      padding-bottom: space(2);
      font-weight: 700;
      list-style: none;
      cursor: pointer;
      border-bottom: 1px solid c('grey');

      &::-webkit-details-marker {
        display: none;
      }

      &:before {
        content: '';
        position: absolute;
        top: -1 * space(1);
        right: 0;
        display: block;
        width: 15px;
        height: 100%;
        background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMnB4IiBoZWlnaHQ9IjZweCIgdmlld0JveD0iMCAwIDEyIDYiPiAgPHBvbHlnb24gZmlsbD0iIzExMTExMSIgcG9pbnRzPSI2LDYgMCwwLjcgMC43LDAgNiw0LjcgMTEuMywwIDEyLDAuNyAiLz48L3N2Zz4=');
        background-repeat: no-repeat;
        background-position: right center;
        transition: 0.5s transform $out-quad;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 1px;
        background: c('green');
        transform: scaleX(0);
        transform-origin: left;
        transition: 0.5s transform $out-quad;
      }
    }

    details[open] {
      summary:before {
        transform: rotate(180deg);
        transition: 0.5s transform $out-quad;
      }
    }

    details:hover {
      summary {
        &:after {
          content: '';
          transform: scaleX(1);
        }
      }
    }

  }
</style>
<!-- eslint-disable -->
